import { retrieveProductList } from '@/api/product'
import { useLanguageStore } from '@/pinia/language'
import { TRANSLATE_MAP } from '@/utils/constants'
import { buriedPointUtil, debounce, gaAnalytics, openURLWithChannelQuery } from '@/utils/utils'

export const useFeaturedSearch = () => {
  const route = useRoute()
  const router = useRouter()
  const language = useLanguageStore()

  const isTagActive = ref(true)

  const tagName = computed(() => {
    return TRANSLATE_MAP[language.current]?.[route.params.category]
  })

  const inputValue = ref('')

  const handleSubmit = async () => {
    if (!inputValue.value && !isTagActive.value) {
      return
    }

    /**
     * 业务埋点：网页Featured页面内搜索
     */
    buriedPointUtil({ eventId: 'PFS201' })

    const query = {}
    if (inputValue.value) {
      query.keyword = inputValue.value
    }
    let href
    if (isTagActive.value) {
      const resolved = router.resolve({
        name: 'featured',
        params: {
          category: route.params.category,
          collectionId: route.params.collectionId
        },
        query
      })
      href = resolved.href
    } else {
      const resolved = router.resolve({
        name: 'search',
        query
      })
      href = resolved.href
    }
    openURLWithChannelQuery(href)
  }

  return {
    isTagActive,
    tagName,
    inputValue,
    handleSubmit
  }
}

export const useCategorySearch = () => {
  const route = useRoute()
  const router = useRouter()
  const store = useStore()
  const language = useLanguageStore()
  const searchInfo = computed(() => store.state.searchInfo)

  const isTagActive = ref(!!route.query.categoryName)
  const tagName = computed(() => route.query.categoryName)
  const inputValue = ref('')

  const lastQuery = ref('')

  const handleInputChange = debounce((e) => {
    inputValue.value = e.target.value
    if (e.target.value.length >= lastQuery.value.length) {
      lastQuery.value = e.target.value
    }
    if (e.target.value.length < lastQuery.value.length) {
      lastQuery.value = e.target.value
      return
    }
    retrieveProductList({
      ...searchInfo.value,
      keyword: e.target.value,
      language: language.current,
      pageSize: 50,
      pageNow: 1,
      imageId: 0,
      region: '',
      async: true
    })
  }, 400)

  const handleSubmit = async () => {
    gaAnalytics('p_search_click', 'p_search_click')
    buriedPointUtil({ eventId: 'PSC201' })
    if (!inputValue.value && !isTagActive.value) {
      return
    }

    const query = {}

    if (inputValue.value) {
      query.keyword = inputValue.value
      query.lg = language.current
    }
    if (isTagActive.value) {
      query.categoryId = route.query.categoryId
      query.categoryName = route.query.categoryName
    }
    const { href } = router.resolve({
      name: 'search',
      query
    })

    openURLWithChannelQuery(href)
  }

  onMounted(() => {
    const { keyword = '' } = route.query
    if (keyword) {
      document.title = keyword
    }
  })

  return {
    isTagActive,
    tagName,
    inputValue,
    handleInputChange,
    handleSubmit
  }
}

export const useSearch = () => {
  const route = useRoute()
  const featured = useFeaturedSearch()
  const category = useCategorySearch()

  return computed(() => {
    if (route.name === 'featured') {
      featured.inputValue.value = route.query.keyword
      return featured
    } else {
      category.inputValue.value = route.query.keyword
      return category
    }
  })
}
